"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _BackArrow = _interopRequireDefault(require("./../Icons/BackArrow"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  background-color: ", ";\n  font-size: 1.6rem;\n  border-radius: 0.5rem;\n  min-width: 12rem;\n  height: 4rem;\n  color: ", ";\n  line-height: 20px;\n  border: 0;\n  padding: 0 1.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  :focus {\n    outline: none;\n  }\n\n  :hover {\n    /* background-color: #FFBF80; */\n  }\n\n  svg {\n    margin-right: 1.15vw;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BackButton = function BackButton(_ref) {
  var onClick = _ref.onClick,
      background = _ref.background,
      icon = _ref.icon,
      name = _ref.name,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["onClick", "background", "icon", "name", "className"]);

  return _react.default.createElement(StyledButton, _extends({
    onClick: onClick,
    className: className,
    background: background
  }, otherProps), icon, name);
};

var StyledButton = _styledComponents.default.button(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var background = _ref3.background;
  return background ? background : 'initial';
}, function (_ref4) {
  var background = _ref4.background,
      theme = _ref4.theme;
  return background ? '#FFFFFF' : theme.typo.highlight;
});

BackButton.defaultProps = {
  icon: _react.default.createElement(_BackArrow.default, null),
  name: 'Back',
  onClick: function onClick() {
    console.log('back button clicked');
  },
  otherProps: {}
};
BackButton.propTypes = {
  background: _propTypes.string,

  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,
  name: _propTypes.string,

  /** Triggered when button is clicked */
  onClick: _propTypes.func.isRequired,

  /** Adds icon to button */
  icon: _propTypes.node,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = BackButton;
exports.default = _default;